import styled from '@emotion/styled'
import { createPropFilter } from '@news-mono/web-common'
import { calcRem, colors } from '../../__styling'

export const StyledAdSlotRoot = styled('div')({
    position: 'relative',
    width: '100%',
    height: '100%',
})

export const StyledAdContainer = styled('div')({
    position: 'absolute',
    inset: 0,
    zIndex: 2,
})

export const StyledAdVideo = styled('video')({
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
})

export const StyledAdLoader = styled('div')({
    position: 'absolute',
    inset: 0,
    zIndex: 3,
    pointerEvents: 'none',
})

export const StyledAdOverlay = styled('div')({
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 3,
    pointerEvents: 'auto',
})

export const StyledAdPauseButton = styled('button')({
    position: 'absolute',
    left: calcRem(16),
    bottom: calcRem(40),
    width: calcRem(44),
    height: calcRem(44),
    borderRadius: '50%',
    border: 'none',
    background: 'rgba(0,0,0,0.6)',
    color: colors.white,
    cursor: 'pointer',
    pointerEvents: 'auto',
})

export const StyledAdMuteWrapper = styled('div')({
    position: 'absolute',
    inset: 0,
    zIndex: 4,
    pointerEvents: 'none',

    '& [class*="StyledUnmuteButton"]': {
        top: calcRem(10) + '!important',
        left: 'auto',
        right: calcRem(16),
        bottom: 'auto',
        zIndex: 4,
        pointerEvents: 'auto',
    },
})

export const StyledAdTimelineHitArea = styled('div')({
    width: '100%',
    paddingTop: calcRem(8),
    paddingBottom: calcRem(8),
    pointerEvents: 'auto',
})

export const StyledAdTimelineTrack = styled('div')({
    height: calcRem(4),
    background: 'rgba(255,255,255,0.25)',
    width: '100%',
})

interface StyledAdTimelineProgressProps {
    progress: number
}

export const StyledAdTimelineProgress = styled('div', {
    shouldForwardProp: createPropFilter<StyledAdTimelineProgressProps>()([
        'progress',
    ]),
})<StyledAdTimelineProgressProps>(({ progress }) => ({
    height: '100%',
    width: `${Math.round(progress * 100)}%`,
    background: colors.sevennews.turbo,
}))
